import type { InstanceConfig } from '../instance-config';

/**
 * Funding variant configuration (Ngai Tahu / Funding Organisations).
 *
 * Key differences from procurement:
 * - 2 KB types (Global + Funding) instead of 3
 * - Global KB is 1 step (no output template)
 * - Funding KB is 4 steps (Upload Form, Selection Criteria, Good Examples, Output Template)
 * - Categories: Funds / Grants / Scholarships (not Goods / Works / Consulting)
 * - No Document Validation feature
 * - No language selection (English only for Phase 1)
 * - No Application Setup (removed per Matt's direction)
 */
export const fundingConfig: InstanceConfig = {
  variant: 'funding',

  // Overridden at runtime by InstanceConfigProvider from NEXT_PUBLIC_CLIENT_NAME.
  clientName: 'ngaitahu',

  kbCategories: [
    {
      id: 'global',
      labelKey: 'kb.tabGlobal',
      url: '/bases/global',
      wizardConfigId: 'funding-global',
    },
    {
      id: 'funding',
      labelKey: 'kb.tabFunding',
      url: '/bases/funding',
      filterTabs: ['Funds', 'Grants', 'Scholarships'],
      wizardConfigId: 'funding',
    },
  ],

  navigation: {
    adminItems: [
      { labelKey: 'nav.dashboard',          href: '/',                      iconName: 'HomeSmile' },
      { labelKey: 'nav.knowledgeBases',     href: '/bases/global',          iconName: 'BookOpen02' },
      { labelKey: 'nav.assessApplications', href: '/assess-applications',   iconName: 'CheckDone01' },
      { labelKey: 'nav.analytics',          href: '/analytics',             iconName: 'LineChartUp01', disabled: true },
    ],
    operatorItems: [
      { labelKey: 'nav.dashboard',          href: '/',                      iconName: 'HomeSmile' },
      { labelKey: 'nav.assessApplications', href: '/assess-applications',   iconName: 'CheckDone01' },
    ],
    footerItems: [
      { labelKey: 'nav.team', href: '/user-management', iconName: 'Users01' },
    ],
  },

  features: {
    documentValidation: false,
    languageSelection: false,
    projectKB: false,
    applicationSetup: false,
  },

  activityKBCategory: 'funding',
  terminologyPrefix: 'funding',
  assessmentBasePath: '/assess-applications',
};
